import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

// Model
import {ResponseBase} from '../models/response-base';

@Injectable({
    providedIn: 'root'
})
export class DonationsService {
    API: string = environment.GATEWAY + 'dashboard';

    constructor(private http: HttpClient) {
    }


    getDonations(assignorGuid: string): Observable<ResponseBase<number>> {
        return this.http.get<ResponseBase<number>>(`${this.API}/assignors/${assignorGuid}/donations`);
    }

}
